import BasicLoadable from "../../Loadable/BasicLoadable";

export const LoadableDevConfirmModal = BasicLoadable({
  loader: () => import("./DevConfirmModal"),
  loading: null,
});
